import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirCondition = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 298 188",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M118.57 139.029C118.57 139.029 115.287 143.712 115.415 150.394C115.543 157.076 119.009 161.982 119.009 161.982C119.009 161.982 123.133 166.566 123.21 173.249C123.287 179.932 119.448 184.935 119.448 184.935",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.433 138.958C149.433 138.958 146.15 143.64 146.277 150.323C146.405 157.005 149.872 161.911 149.872 161.911C149.872 161.911 153.996 166.495 154.073 173.178C154.15 179.861 150.311 184.864 150.311 184.864",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.295 138.958C180.295 138.958 177.012 143.64 177.14 150.323C177.268 157.005 180.734 161.911 180.734 161.911C180.734 161.911 184.859 166.495 184.935 173.178C185.012 179.861 181.173 184.864 181.173 184.864",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M273 82.5H26C22.9624 82.5 20.5 84.9624 20.5 88V98H278.5V88C278.5 84.9624 276.038 82.5 273 82.5Z",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 4V13C18 17.4183 21.5817 21 26 21H273C277.418 21 281 17.4183 281 13V4",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 2.5,
			width: 293,
			height: 114,
			rx: 7.5,
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 134.5,
			y1: 63.5,
			x2: 163.5,
			y2: 63.5,
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 249.5,
			cy: 64.5,
			r: 3.5,
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 264.5,
			cy: 64.5,
			r: 3.5,
			fill: "#808080"
		})
	]
});
const ForwardRef = forwardRef(SvgAirCondition);
export default ForwardRef;
